import { render } from "./side-nav-menu.vue?vue&type=template&id=506ee022"
import script from "./side-nav-menu.vue?vue&type=script&lang=js"
export * from "./side-nav-menu.vue?vue&type=script&lang=js"

import "./side-nav-menu.vue?vue&type=style&index=0&id=506ee022&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__